import React, {useEffect} from "react";
import {appdata} from "../../logic_tmp/appdata/AppData";
import queryString from "query-string";
import {registerConcersion} from "../../logic/funel/FacebookUtils";
import {logBack} from "../../backend/connectors/JavaConnector";

export function RedirectToLink() {
    registerConcersion('Search');
    useEffect(() => {
        let queryParams = queryString.parse(window.location.search)
        let redirectTo = queryParams["link"];

        redirectTo =window.atob(redirectTo)

        console.log(redirectTo)
        let utm =
            "aaa=aaa"
        if (redirectTo.includes("duoclassico"))
        {
            if (redirectTo.includes("?")) {
                redirectTo = redirectTo + "&" + utm
            } else
                redirectTo = redirectTo + "?" + utm

        }
        logBack(redirectTo.substr(redirectTo.indexOf("?") + 1));

        window.location.href = redirectTo;
    }, []);
    return (
        <div>
            Redirecting...
        </div>
    );
}

